import * as generated from '@/routes/org/blog/taxonomy';
import { relative } from './relative';
export const index = relative(generated.index);
export const create = relative(generated.create);
export const store = relative(generated.store);
export const edit = relative(generated.edit);
export const update = relative(generated.update);
export const destroy = relative(generated.destroy);
